var render, staticRenderFns
import script from "./foodmenu.vue?vue&type=script&lang=js"
export * from "./foodmenu.vue?vue&type=script&lang=js"
import style0 from "./foodmenu.vue?vue&type=style&index=0&id=f199fc5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f199fc5e",
  null
  
)

export default component.exports